import React, { useCallback, useState } from 'react';
import styled from '@emotion/styled';
import { Colors, Button } from '@blueprintjs/core';
import { useMapContext } from 'widgets/earthMap/contexts/mapContext';
import { useEffect } from 'react';
import * as turf from 'turf';

export default function FitToBoundsButton() {
	const [{ rawData, map }] = useMapContext();
	const [bounds, setBounds] = useState<number[][]>([]);

	useEffect(() => {
		if (!rawData || !map) return;
		try {
			const bbox = turf.bbox(rawData);
			const nw = [bbox[0], bbox[1]];
			const se = [bbox[2], bbox[3]];
			const bounds: number[][] = [nw, se];
			setBounds(bounds);
			map.fitBounds(bounds);
		} catch {
			//error
		}
	}, [map, rawData]);

	const onClick = useCallback(() => {
		if (!map || !bounds) return;
		map.fitBounds(bounds);
	}, [map, bounds]);

	return (
		<Wrapper>
			<Button icon={'zoom-to-fit'} onClick={onClick} />
		</Wrapper>
	);
}

const Wrapper = styled.div`
	position: absolute;
	left: 12px;
	bottom: 12px;
	background: ${Colors.WHITE};
`;
